(function ($, Drupal, drupalSettings) {

  'use strict';

})(jQuery, Drupal, drupalSettings);
